import { MonitoringBackEndDataSourceModel } from './monitoring-back-end-data-source.model';
import { MonitoringSeriesTypeEnum } from '../enums/monitoring-series-type.enum';
import { BrandIdentity } from '../../../Common/BrandIdentity/models/brand-identity';
import { BriefingImagePropertiesModel } from '../../../Common/PageBuilder/models/briefing-image-properties.model';

export class MonitoringBrand {
    brand: BrandIdentity | null = null;
    name: string = '';
    logo: BriefingImagePropertiesModel[] = [];
    color: string = '';
    dataSource: MonitoringBackEndDataSourceModel = new MonitoringBackEndDataSourceModel(MonitoringSeriesTypeEnum.folder);
}
